/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function set2DayShippingInfo() {
  var localTime = new Date();
  // console.log("Local machine time is: " + localTime + "<br>");	
  // console.log(localTime.getDay());
  var endTime = new Date(Date.UTC(localTime.getFullYear(), localTime.getMonth(), localTime.getDate()));
  endTime.setHours(endTime.getHours() + 19);
  var diffMs = (endTime - localTime);
  var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
  if(diffHrs >= 0) {
    $('.2-day-shipping-info').html(`Place order in the next ${diffHrs} hours and ${ diffMins } mins for 2 day shipping`)
  } else {
    $('.2-day-shipping-info').html('2 day shipping orders will be processed tomorrow');
  }
}

window.setInterval(function(){
  set2DayShippingInfo();

}, 1000);

const sliderNextArrowButton = document.querySelector('.slider-next-arrow');
if (sliderNextArrowButton) {
  const flkty = Flickity('.slideshow');
  if (flkty) {
    sliderNextArrowButton.onclick = function() {
      flkty.next();
    }
  }
}

// Center hanni logo no matter what.
// function centerHanniLogo() {
//   const logo = $('.header__logo');

//   if (logo && isLaptopAndUp()) {
//     logo.css("transition","all 200ms");
//     logo.css("position","absolute");
//     logo.css("left", Math.max(0, (($(window).width() - logo.outerWidth()) / 2) + $(window).scrollLeft()) + "px");
//   } else {
//     logo.css("position", "unset");
//     logo.css("left", "unset");
//   }
// }

function positionArrow() {
  const arrow = $('.slider-next-arrow');
  const dots = $('.flickity-page-dots');

  if (arrow.length && dots.length) {
    const widthWindow = $(window).width();
    const { left: dotX } = dots.offset();
    const widthDot = dots.outerWidth();
    const widthPadding = widthWindow * 0.06// 6 vw;
    let value = Math.max(0, (widthWindow - (dotX + widthDot)) - widthPadding - 34);
    if (window.innerWidth > 500) {
      value += 18;
    }
    arrow.css("right", `${value}px`);
  }
}

// Full title br tag correction
function correctBrTag() {
  const pTag = $('.display-br p');
  if (pTag.length && isMobile()) {
    pTag[0].innerHTML = pTag[0].innerHTML.replace('<br> <br>', '<br><br>').replace(/([\w|\s])(<br>)([\w|\s])/g, '$1$3');
  }
}

function isMobile() {
  return window.innerWidth <= 640;
}

function isLaptopAndUp() {
  return window.innerWidth > 1000;
}

$(document).ready(function() {
  positionArrow();
  correctBrTag();
  // Resize event handler.
  $(window).resize(function() {
    centerHanniLogo();
    positionArrow();
    correctBrTag();
  });

  const heightBtn = $(".section-slideshow-products").find('.product-item__action-button').innerHeight();
  const marginBottom = Number($(".section-slideshow-products").css('margin-top')?.replace('px', ''));

  //  Hover Script  [ Product-item.liquid }
  $(".product-item").mouseover(function() {
    if (isLaptopAndUp()) {
      $(this).find("div .imgPpal").hide();
      $(this).find("div .hover-gif").show();
    }

    if($(this).find("button.product-item__action-button.button.button--small.button--primary").length > 0){
      $(this).find("button.product-item__action-button.button.button--small.button--primary").show();
    } else{
      $(this).find("button.button--ternary").show();
      $(this).find(".product-item__action-button").css("display","block");
    }
    $(this).find(".product-item__info").css("margin-top","0");


    $(".section-slideshow-products").css('margin-bottom', marginBottom - heightBtn);

  })
  .mouseout(function() {
    if (isLaptopAndUp()) {
      $(this).find("div .imgPpal").show();
      $(this).find("div .hover-gif").hide();
    }
    $(this).find("button.product-item__action-button.button.button--small.button--primary").hide();
    $(this).find("button.button--ternary").hide();
    $(this).find(".product-item__action-button").css("display","none");
    $(this).find(".product-item__info").css("margin-top","0");

    $(".section-slideshow-products").css('margin-bottom', marginBottom);
  });

});

//  $(window).on("load", function() {
//   var artHeight = $('div#shopify-section-16291428945e610201 .slideshow__slide').outerHeight();
//   $('div#shopify-section-16291428945e610201 .flickity-viewport').css({
//     'height' : artHeight
//   });
// });

$( window ).resize(function() {
//   $( "div#shopify-section-16291428945e610201" ).css("margin-bottom",0);
  $( "div#shopify-section-16291428945e610201   .mobilebtnSlider" ).css("margin-top","15px");
  $( "div#shopify-section-16291428945e610201   .flickity-page-dots" ).css("bottom","80px");
});

   setTimeout(function(){
     $( "div#shopify-section-16291428945e610201 .slideshow__content-wrapper").fadeTo("slow", 1);
     }, 500);

     function addItemToCart(variant_id, qty, removekey) {
      var data = {
        "id": variant_id,
        "quantity": qty
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    'id': removekey,
                    'quantity': 0,
                },
                dataType: 'json',
                success: function (cart) {
                  window.location.href = "/cart";
                },
                error: function (xhr, status, error) {
                    console.log('--error--', eval("(" + xhr.responseText + ")"))
                }
            });
          $('.mini-cart').attr('aria-expanded', 'true');
        }
      });
  }
  $( document ).ready(function() {
  $(document).on('click','.custom-submit-button',function(){   
      addItemToCart($(this).attr("data-id"), $(this).attr("data-quantity"), $(this).attr("data-key"));
  });
});



$(document).ready(function() {
  $(document).on('click', '#close_up_product', function() {
    // Find the closest parent element with the class 'ctm-upshell-box' and hide it
    $(this).closest('.ctm-upshell-box').hide();
  });
});



// $( document ).ready(function() {
//   $(document).on('click','.ctm-mobi-mega-3 button.menu-arrow',function(e){ 
//     e.preventDefault();
//  // $('.ctm-mobi-mega-3 button.menu-arrow').toggleClass('dropdown-rotate');
//  $('.ctm-mobi-mega-3 ul.sub-menu').toggleClass('show');
//   });
// });     

// tolstoy story slider reload
$(document).ready(function() {
      $('.tolstoy-carousel').load(location.href + ' .tolstoy-carousel');
});

// swatch js
$('select.prodswat').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
    $('.shade-btn').attr('data-variant',valueSelected);
  console.log($(this).find(':selected').attr('data-qty'));
  console.log($(this).closest('.shade-btn'));
    if ($(this).find(':selected').attr('data-qty') === "0") {
      
      $(this).closest("form").children(".shade-btn").attr("disabled", "disabled");
      $(this).closest("form").children(".shade-btn").text("sold out");
    } else {
      $(this).closest("form").children(".shade-btn").removeAttr("disabled");
      $(this).closest("form").children(".shade-btn").text("quick add");
    }
});
function redirectToCart() {
  window.location = "/cart"
}
$('.shade-btn').click(function(){                               
    var variant_id = $(this).attr('data-variant');
    console.log(variant_id);
    var qty = 1;
    data = {
		"id": variant_id,
		"quantity": qty
	}
	jQuery.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: data,
		dataType: 'json',
		success: redirectToCart
	});
     
 })
 var cartpath = window.location.pathname;
if(cartpath == '/cart')
{
cartupdate();
}
function cartupdate(){
    $.getJSON('/cart.js', function(data){
     var items = data.items;
       
     var total = data.total_price;
     var free_gift_over_price_40 = 7500;  
    var variant_id = "41220726980661";
    var currentVarId;
     var quantity;
      var producthandle;
       var isgwpprod;
     var isProduct = false;
      var producttag;
         console.log(data);
        items.forEach(function(e,i,a){
         currentVarId = e.variant_id;
          producthandle = e.handle;
          if(currentVarId == variant_id) {
           isProduct = true;
           quantity = e.quantity;
          
           if(e.properties && e.properties.is_gwp){
             isgwpprod = true;
           }
         }
         if(e.handle == 'acc-hydration-duo' || e.handle == 'shave-duo-free-gift'){
           producttag = true;
         }
              
       });
 if(producttag)
                         {
                             if(!isgwpprod) {
                            $.ajax({
                              type: 'POST',
                              url: '/cart/add.js',
                              data: {
                                 quantity: 1,
                                 id: variant_id,
                                properties: {
                                  is_gwp: true
                                }
                              },
                              dataType: 'json',
                              success: function (response) {
                                //cartdrawerSetResponce();
                                },
                            });
                          }    
                         }
                           else{
                            if(isProduct && isgwpprod) {
                              $.ajax({
                              type: 'POST',
                              url: '/cart/change.js',
                              data: {
                                 quantity: 0,
                                 id: variant_id,
                                properties: {
                                  is_gwp: true
                                }
                              },
                              dataType: 'json',
                              success: function (response) {
                                //cartdrawerSetResponce();
                                },
                            });
                            }
                           }
       
  
});
  }

// PDP edits 21-09-23 start
$(document).ready(function() {
  if ($(window).width() < 999) {
    // Scroll to section 2 with a delay
    setTimeout(function() {
      $("html, body").animate({
        scrollTop: $(".product-gallery__carousel-wrapper").offset().top
      }, 200); // You can adjust the duration as needed
    }, 1000); // Add a delay (in milliseconds) between scrolling to sections
  }
});
// PDP edits 21-09-23 end